import React, { useEffect, useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAppContext } from "../utils/context/app-context";
import {
	Button,
	ContentContainer,
	TitleHeader,
	TableLoading,
	MaterialIcon,
	AlertMessage,
} from "../components/UiComponents";
import { CourseHeader, CourseWrapper } from "../components/CourseComponents";
import { questions } from "./PhysicalCompetencyPage";
import useDocumentTitle from "../components/useDocumentTitle";
import { Modal, Dropdown } from "react-bootstrap";
import {
	SelectInput,
	FormBeforeAfterContent,
} from "../components/FormComponents";
import { useUserIsReadOnly } from "../components/userFunctions";

const AttendanceContext = React.createContext();

const AttendanceRegisterPage = () => {
	const { state, dispatch, api } = useAppContext();
	const isOffline = state.offline;
	useDocumentTitle("Attendance Register");
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [markingPassed, setMarkingPassed] = useState(false);
	const [markingPassedError, setMarkingPassedError] = useState(null);
	const [markingPassedSuccess, setMarkingPassedSuccess] = useState(null);
	const [selectedMergeStudent, setSelectedMergeStudent] = useState(null);
	const [mergeModalOpen, setMergeModalOpen] = useState(false);
	const [studentMerged, setStudentMerged] = useState(false);

	const [selectedDeleteStudent, setSelectedDeleteStudent] = useState(null);
	const [deleteModalOpen, setDeleteModalOpen] = useState(false);
	const [studentDeleted, setStudentDeleted] = useState(false);
	let course = api.getCurrentCourse();
	let date = api.getCurrentDate();
	const extraContent = state?.forms_extra_content["attendance_register"] || {};
	const isReadOnly = useUserIsReadOnly();
	const [markingPresent, setMarkingPresent] = useState(false);
	const [markingPresentError, setMarkingPresentError] = useState(null);
	const [markingPresentSuccess, setMarkingPresentSuccess] = useState(null);

	const [markingNotPresent, setMarkingNotPresent] = useState(false);
	const [markingNotPresentError, setMarkingNotPresentError] = useState(null);
	const [markingNotPresentSuccess, setMarkingNotPresentSuccess] =
		useState(null);

	const [sendingEmail, setSendingEmail] = useState(false);
	const [sendingEmailError, setSendingEmailError] = useState(null);
	const [sendingEmailSuccess, setSendingEmailSuccess] = useState(null);

	const [approvingHQ, setApprovingHQ] = useState(false);
	const [approvingHQError, setApprovingHQError] = useState(null);
	const [approvingHQSuccess, setApprovingHQSuccess] = useState(null);

	useEffect(() => {
		fetchData();
	}, []);

	async function fetchData() {
		if (isOffline) {
			setLoading(false);
			return;
		}
		setLoading(true);

		const { data } = await api.fetchData(
			`/attendance/${course.id}/${state.current_date_id}`
		);

		console.log("Attendance Register Data:", data);

		if (data?.data) {
			dispatch({
				type: "SET_DATE_ATTENDANCE",
				payload: {
					attendance: data.data,
					course_id: course.id,
					date_id: state.current_date_id,
				},
			});
			setLoading(false);
		} else {
			setLoading(false);
		}
	}

	// Mark all students as passed, or just the selected student
	async function markAllPassed(selected_student_id = null) {
		const students = date.attendance;
		if (students) {
			let to_mark_passed = [];
			// Loop students and any students that have has_physical_competency = 0, add to array
			students.forEach((student) => {
				if (student.has_physical_competency == 0) {
					console.log(selected_student_id);
					// If no student_id is passed, mark all students as passed
					if (!selected_student_id) {
						to_mark_passed.push(student);
					} else if (student.student_id == selected_student_id) {
						to_mark_passed.push(student);
					}
				}
			});

			// If array has students, mark them as passed
			if (to_mark_passed.length > 0) {
				let dataToPost = {
					course_id: course.id,
					form_data: {
						students: {},
						comments: null,
					},
				};
				let answers = {};
				// Loop questions object and set to 1
				for (const [key, value] of Object.entries(questions)) {
					answers[key] = 1;
				}

				// Loop students and add them to the form_data object
				to_mark_passed.forEach((student) => {
					dataToPost.form_data.students[student.student_id] = answers;
				});

				setMarkingPassed(true);
				setMarkingPassedError(null);
				setMarkingPassedSuccess(false);

				const { data, error } = await api.fetchData(
					`/forms/physical-competency-form`,
					"POST",
					dataToPost
				);
				console.log(data);
				if (data?.success) {
					// Loop students and set has_physical_competency to 1
					to_mark_passed.forEach((student) => {
						dispatch({
							type: "SET_STUDENT_PHYSICAL_COMPETENCY",
							payload: {
								student_id: student.student_id,
								course_id: course.id,
								date_id: date.id,
								val: 1,
								result: 1,
							},
						});
					});
					setMarkingPassed(false);
					setMarkingPassedSuccess(true);
				} else {
					setMarkingPassed(false);
					setMarkingPassedError(
						error || data?.error || "An error occurred"
					);
				}
			}
		}
	}

	async function markPresent(studentId) {
		setMarkingPresent(true);

		const { data, error } = await api.fetchData(
			`/attendance/mark-present`,
			"POST",
			{
				course_id: course.id,
				date_id: state.current_date_id,
				student_id: studentId,
			}
		);

		if (data?.success) {
			dispatch({
				type: "SET_STUDENT_ATTENDANCE",
				payload: {
					student_id: studentId,
					course_id: course.id,
					date_id: state.current_date_id,
					val: 1,
				},
			});
			setMarkingPresent(false);
			setMarkingPresentSuccess(true);
		} else {
			setMarkingPresent(false);
			setMarkingPresentError(error || data?.error || "An error occurred");
		}
	}

	async function markNotPresent(studentId) {
		setMarkingNotPresent(true);

		const { data, error } = await api.fetchData(
			`/attendance/mark-not-present`,
			"POST",
			{
				course_id: course.id,
				date_id: state.current_date_id,
				student_id: studentId,
			}
		);

		if (data?.success) {
			dispatch({
				type: "SET_STUDENT_NON_ATTENDANCE",
				payload: {
					student_id: studentId,
					course_id: course.id,
					date_id: state.current_date_id,
					val: 1,
				},
			});
			setMarkingNotPresent(false);
			setMarkingNotPresentSuccess(true);

			// Redirect to /courses/${course.id}/refer/${studentId}
			navigate(`/courses/${course.id}/refer/${studentId}`);
		} else {
			setMarkingNotPresent(false);
			setMarkingNotPresentError(error || data?.error || "An error occurred");
		}
	}

	async function sendWelcomeEmail(studentId) {
		setSendingEmail(true);

		const { data, error } = await api.fetchData(
			`/students/${studentId}/send-welcome-email`,
			"POST",
			{
				course_id: course.id,
				date_id: state.current_date_id,
			}
		);

		console.log(data);

		if (data?.success) {
			setSendingEmail(false);
			setSendingEmailSuccess(true);
		} else {
			setSendingEmail(false);
			setSendingEmailError(error || data?.error || "An error occurred");
		}
	}

	function hasStudentsWithoutResult() {
		let has = false;
		date.attendance.forEach((student) => {
			if (student.has_physical_competency == 0) {
				has = true;
			}
		});
		return has;
	}

	// Split students into two groups: needs attention vs no concerns
	function getStudentGroups() {
		if (!date?.attendance) return { needsAttention: [], noConcerns: [] };

		const needsAttention = [];
		const noConcerns = [];

		date.attendance.forEach((student) => {
			// Needs attention: HQ not submitted, or has flagged answers, or HQ not yet checked by tutor
			const hqNotSubmitted = !student.health_form_id;
			const hasFlaggedAnswers = student.has_health_flag_answers == 1;

			if (course.requires_health_questionnaire == 1 && (hqNotSubmitted || hasFlaggedAnswers)) {
				needsAttention.push(student);
			} else {
				noConcerns.push(student);
			}
		});

		return { needsAttention, noConcerns };
	}

	// Check if there are any unchecked no-concern HQs that can be bulk approved
	function getUncheckedNoConcernIds() {
		const { noConcerns } = getStudentGroups();
		return noConcerns.filter(
			(s) => s.health_form_id && !s.health_form_checked && course.requires_health_questionnaire == 1
		);
	}

	async function bulkApproveNoConcerns() {
		const unchecked = getUncheckedNoConcernIds();
		if (unchecked.length === 0) return;

		const questionnaireIds = unchecked.map((s) => s.health_form_id);

		setApprovingHQ(true);
		setApprovingHQError(null);
		setApprovingHQSuccess(null);

		const { data, error } = await api.fetchData(
			`/sign-health-questionnaires`,
			"POST",
			{
				course_id: course.id,
				date_id: state.current_date_id,
				questionnaire_id: questionnaireIds,
				comments: "Participant has reported no health concerns (answered No to all questions)",
			}
		);

		if (data?.success) {
			setApprovingHQ(false);
			setApprovingHQSuccess(true);
			// Re-fetch to update the health_form_checked statuses
			fetchData();
		} else {
			setApprovingHQ(false);
			setApprovingHQError(error || data?.message || "An error occurred");
		}
	}

	function handleMergeOpenClicked(student) {
		setSelectedMergeStudent(student);
		setMergeModalOpen(true);
		setStudentMerged(false);
	}

	function handleCloseMergeModal() {
		setMergeModalOpen(false);
		setStudentMerged(false);
	}

	function onStudentMerged(student_id) {
		dispatch({
			type: "REMOVE_STUDENT_FROM_DATE",
			payload: {
				student_id: student_id,
				course_id: course.id,
				date_id: state.current_date_id,
			},
		});
		fetchData();
		setStudentMerged(true);
		setMergeModalOpen(false);
	}

	function handleDeleteOpenClicked(student) {
		setSelectedDeleteStudent(student);
		setDeleteModalOpen(true);
		setStudentDeleted(false);
	}

	function handleCloseDeleteModal() {
		setDeleteModalOpen(false);
		setStudentDeleted(false);
	}

	function onStudentDeleted(student_id) {
		dispatch({
			type: "REMOVE_STUDENT_FROM_DATE",
			payload: {
				student_id: student_id,
				course_id: course.id,
				date_id: state.current_date_id,
			},
		});
		fetchData();
		setStudentDeleted(true);
		setDeleteModalOpen(false);
	}

	const attendanceContextData = {
		markPresent,
		markNotPresent,
		markingPresent,
		markingPresentError,
		markingPresentSuccess,
		markingNotPresent,
		markingNotPresentError,
		markingNotPresentSuccess,
		sendWelcomeEmail,
		sendingEmail,
		sendingEmailError,
		sendingEmailSuccess,
	};

	const HeaderButtons = () => {
		return (
			<div className="attendance-register-page__action-buttons">
				{!isOffline && (
					<>
						{hasStudentsWithoutResult() &&
							course.requires_physical_competency == 1 && (
								<Button
									text={
										markingPassed ? "Marking..." : "Mark All Passed"
									}
									type="outline-success"
									size="sm"
									onClick={() => markAllPassed()}
									disabled={isReadOnly}
								/>
							)}
						<Link
							to={`/courses/${course.id}/participants/create`}
							className="btn btn-sm btn-success">
							Add New Participant
						</Link>
					</>
				)}
			</div>
		);
	};

	return (
		<AttendanceContext.Provider value={attendanceContextData}>
			<div className="attendance-register-page">
				<CourseHeader />
				<ContentContainer classes="mb-4">
					<CourseWrapper>
						<TitleHeader
							title={`Registered Participants${!loading ? ` (${date.attendance.length}${course.places_available ? ` of ${course.places_available} places` : ''})` : ''}`}
							rightContent={loading ? null : <HeaderButtons />}
						/>
						<div className="attendance-register">
							{loading ? (
								<TableLoading rows={5} />
							) : (
								<>
									{date.attendance.length == 0 ? (
										<div className="attendance-register__empty">
											<p>No Participants have registered yet.</p>
										</div>
									) : (
										<>
											{/* Global alert messages */}
											{markingPresent && (
												<div className="mb-3">
													<AlertMessage
														type="info"
														message="Marking Present..."
													/>
												</div>
											)}
											{markingPresentError && (
												<div className="mb-3">
													<AlertMessage
														type="danger"
														message={markingPresentError}
													/>
												</div>
											)}
											{markingPresentSuccess && (
												<div className="mb-3">
													<AlertMessage
														type="success"
														message="Participant marked as present"
													/>
												</div>
											)}
											{markingNotPresent && (
												<div className="mb-3">
													<AlertMessage
														type="info"
														message="Marking Not Present..."
													/>
												</div>
											)}
											{markingNotPresentError && (
												<div className="mb-3">
													<AlertMessage
														type="danger"
														message={markingNotPresentError}
													/>
												</div>
											)}
											{markingNotPresentSuccess && (
												<div className="mb-3">
													<AlertMessage
														type="success"
														message="Participant marked as not present"
													/>
												</div>
											)}
											{sendingEmail && (
												<div className="mb-3">
													<AlertMessage
														type="info"
														message="Sending Welcome Email..."
													/>
												</div>
											)}
											{sendingEmailError && (
												<div className="mb-3">
													<AlertMessage
														type="danger"
														message={sendingEmailError}
													/>
												</div>
											)}
											{sendingEmailSuccess && (
												<div className="mb-3">
													<AlertMessage
														type="success"
														message="Welcome Email sent"
													/>
												</div>
											)}
											{markingPassedError && (
												<div className="mb-3">
													<AlertMessage
														type="danger"
														message={markingPassedError}
													/>
												</div>
											)}
											{markingPassedSuccess && (
												<div className="mb-3">
													<AlertMessage
														type="success"
														message="Participants marked as passed"
													/>
												</div>
											)}
											{studentMerged && (
												<div className="mb-3">
													<AlertMessage
														type="success"
														message="Participants merged successfully"
													/>
												</div>
											)}
											{studentDeleted && (
												<div className="mb-3">
													<AlertMessage
														type="success"
														message="Participant and associated records successfully deleted"
													/>
												</div>
											)}
											{approvingHQError && (
												<div className="mb-3">
													<AlertMessage
														type="danger"
														message={approvingHQError}
													/>
												</div>
											)}
											{approvingHQSuccess && (
												<div className="mb-3">
													<AlertMessage
														type="success"
														message="Health Questionnaires with no concerns have been approved and locked"
													/>
												</div>
											)}

											{/* Section 1: Needs Attention (flagged health concerns or HQ not submitted) */}
											{course.requires_health_questionnaire == 1 && (
												<>
													<h5 className="attendance-register__section-title attendance-register__section-title--attention">
														<MaterialIcon icon="flag" className="attendance-register__section-icon" />
														Needs Attention — Health Concerns or Not Yet Submitted ({getStudentGroups().needsAttention.length})
													</h5>
													{getStudentGroups().needsAttention.length === 0 ? (
														<div className="attendance-register__no-attention">
															<AlertMessage
																type="success"
																message="All participants have submitted their Health Questionnaires with no flagged concerns."
															/>
														</div>
													) : (
														<StudentsTable
															students={getStudentGroups().needsAttention}
															openMergeModal={handleMergeOpenClicked}
															openDeleteModal={handleDeleteOpenClicked}
															markPassed={markAllPassed}
															showPhysicalCompetency={
																course?.requires_physical_competency == 1
															}
														/>
													)}

													{/* Section 2: No Concerns */}
													<div className="attendance-register__section-header">
														<h5 className="attendance-register__section-title attendance-register__section-title--ok">
															<MaterialIcon icon="check_circle" className="attendance-register__section-icon" />
															No Health Concerns ({getStudentGroups().noConcerns.length})
														</h5>
														{!isOffline && !isReadOnly && getUncheckedNoConcernIds().length > 0 && (
															<Button
																text={approvingHQ ? "Approving..." : `Approve and Lock Health Questionnaires with No Concerns (${getUncheckedNoConcernIds().length})`}
																type="outline-success"
																size="sm"
																onClick={bulkApproveNoConcerns}
																disabled={approvingHQ}
																className="mb-3"
															/>
														)}
														{approvingHQ && (
															<div className="mb-3">
																<AlertMessage
																	type="info"
																	message="Approving and locking Health Questionnaires..."
																/>
															</div>
														)}
													</div>
													{getStudentGroups().noConcerns.length > 0 && (
														<StudentsTable
															students={getStudentGroups().noConcerns}
															openMergeModal={handleMergeOpenClicked}
															openDeleteModal={handleDeleteOpenClicked}
															markPassed={markAllPassed}
															showPhysicalCompetency={
																course?.requires_physical_competency == 1
															}
														/>
													)}
												</>
											)}

											{/* If HQ is not required, show a single table */}
											{course.requires_health_questionnaire != 1 && (
												<StudentsTable
													students={date.attendance}
													openMergeModal={handleMergeOpenClicked}
													openDeleteModal={handleDeleteOpenClicked}
													markPassed={markAllPassed}
													showPhysicalCompetency={
														course?.requires_physical_competency == 1
													}
												/>
											)}

											<MergeModal
												show={mergeModalOpen}
												selectedStudent={selectedMergeStudent}
												onClose={handleCloseMergeModal}
												students={date.attendance}
												onMerged={onStudentMerged}
											/>

											<DeleteModal
												show={deleteModalOpen}
												selectedStudent={selectedDeleteStudent}
												courseId={course.id}
												onClose={handleCloseDeleteModal}
												onDeleted={onStudentDeleted}
											/>
										</>
									)}
								</>
							)}
						</div>
					</CourseWrapper>
				</ContentContainer>
			</div>
		</AttendanceContext.Provider>
	);
};

const StudentsTable = ({
	students,
	openMergeModal,
	openDeleteModal,
	markPassed,
	showPhysicalCompetency = true,
}) => {
	if (students.length == 0) {
		return null;
	}
	return (
		<table className="table table-striped responsive-table students-table">
			<thead>
				<tr>
					<th>Name</th>
					<th>Email</th>
					<th>Attendance</th>
					<th>Health Questionnaire</th>
					{showPhysicalCompetency && <th>Physical Competency</th>}
					<th>Referral Competency</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				{students.map((student) => (
					<StudentsTableRow
						student={student}
						key={student.student_id}
						openMergeModal={openMergeModal}
						openDeleteModal={openDeleteModal}
						markPassed={markPassed}
						showPhysicalCompetency={showPhysicalCompetency}
					/>
				))}
			</tbody>
		</table>
	);
};

const StudentsTableRow = ({
	courseId,
	student,
	openMergeModal,
	openDeleteModal,
	markPassed,
	showPhysicalCompetency = true,
}) => {
	console.log(student)
	const { state, dispatch, api } = useAppContext();
	const isOffline = state.offline;
	const navigate = useNavigate();
	const { markPresent, markNotPresent, sendWelcomeEmail } =
		useContext(AttendanceContext);
	let competency_class = ["students-table__physical-competency-result"];
	if (student.physical_competency_result === 1) {
		competency_class.push("students-table__physical-competency-result--pass");
	} else if (student.physical_competency_result === 2) {
		competency_class.push("students-table__physical-competency-result--fail");
	}
	const course = api.getCurrentCourse();
	const studentId = student.student_id;
	const isReadOnly = useUserIsReadOnly();
	const isPresent = student.attendance == 1;
	const isNotPresent = student.non_attendance == 1;
	const hasReferralForm = student.has_referral_form == 1;

	const handleMergeOpenClicked = () => {
		openMergeModal(student);
	};

	const handleDeleteOpenClicked = () => {
		openDeleteModal(student);
	};

	return (
		<tr>
			<td>
				{student.first_name} {student.last_name}
			</td>
			<td>{student.email}</td>
			<td>
				{isPresent && (
					<span className="students-table__attendance students-table__attendance--present">
						<MaterialIcon icon="check_circle" />
						Present
					</span>
				)}
				{isNotPresent && (
					<span className="students-table__attendance students-table__attendance--not-present">
						<MaterialIcon icon="cancel" />
						Not Present
					</span>
				)}
				{!isNotPresent && !isPresent && (
					<div className="students-table__action-buttons">
						<Button
							text={"Present"}
							type="btn btn-sm btn-success"
							size="sm"
							onClick={() => markPresent(studentId)}
							disabled={isOffline}
						/>
						<Button
							text="Not Present"
							type="btn btn-sm btn-tertiary"
							size="sm"
							onClick={() => markNotPresent(studentId)}
							disabled={isOffline}
						/>
					</div>
				)}
			</td>
			<td className="text-center" data-label="Health Questionnaire">
				{student.health_form_id ? (
					<div className="students-table__health-form-link">
						{course.requires_health_questionnaire == 1 ? (
							<>
								{student.has_health_flag_answers == 1 && (
									<MaterialIcon
										icon="flag"
										className="students-table__flag"
									/>
								)}
								<Link
									to={`/courses/${course.id}/health-questionnaire/${student.health_form_id}`}>
									View Form
								</Link>
								{student.health_form_checked > 0 ? (
									<MaterialIcon
										icon="check_circle"
										className="students-table__check"
									/>
								) : (
									<MaterialIcon
										icon="check_circle"
										className="students-table__check students-table__check--unchecked"
									/>
								)}
							</>
						) : (
							"N/A"
						)}
					</div>
				) : (
					<>Not Submitted</>
				)}
			</td>
			{showPhysicalCompetency && (
				<td className="text-center" data-label="Physical Competency">
					{student.has_physical_competency == 1 ? (
						<span className={competency_class.join(" ")}>
							{student.physical_competency_result == 1 ? "Passed" : (
								<Link to={`/courses/${course.id}/physical-competency-assessment/${studentId}`} className="students-table__referral-link" style={isOffline ? { pointerEvents: "none", color: "inherit", textDecoration: "none" } : { color: "inherit", textDecoration: "underline" }}>
									Referred
								</Link>
							)}
						</span>
					) : (
						<div className="students-table__action-buttons">
							<Button
								text="Pass"
								type="btn btn-sm btn-outline-success"
								size="sm"
								onClick={() => markPassed(studentId)}
								disabled={isReadOnly || isOffline}
							/>
							<Link
								to={`/courses/${course.id}/physical-competency-assessment/${studentId}`}
								className="btn btn-sm btn-outline-tertiary"
								style={isOffline ? { pointerEvents: "none" } : null}
							>
								Refer
							</Link>
						</div>
					)}
				</td>
			)}
			<td className="text-center">
				{student.physical_competency_result == 2 ||
					!showPhysicalCompetency ||
					hasReferralForm ||
					isNotPresent ? (
					<>
						{!student.has_referral_form ? (
							<Link
								to={`/courses/${course.id}/refer/${studentId}`}
								className="btn btn-sm btn-tertiary">
								Complete Referral
							</Link>
						) : (
							<Link
								to={`/courses/${course.id}/refer/${studentId}`}
								className="students-table__referral-complete">
								Referral Complete
							</Link>
						)}
					</>
				) : (
					<>N/A</>
				)}
			</td>
			<td className="text-center">
				<div className="students-table__action-buttons">
					{!isOffline && (
						<Dropdown>
							<Dropdown.Toggle
								variant="outline-secondary btn-sm"
								id="dropdown-basic">
								Actions
							</Dropdown.Toggle>

							<Dropdown.Menu>
								<Dropdown.Item onClick={handleMergeOpenClicked}>
									Merge
								</Dropdown.Item>
								<Dropdown.Item
									onClick={() =>
										navigate(
											`/courses/${course.id}/participants/${studentId}`
										)
									}>
									Edit
								</Dropdown.Item>
								<Dropdown.Item onClick={() => sendWelcomeEmail(studentId)}>
									Send Welcome Email
								</Dropdown.Item>
								<Dropdown.Divider />
								<Dropdown.Item
									className="text-danger"
									onClick={handleDeleteOpenClicked}>
									Delete
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					)}
				</div>
			</td>
		</tr>
	);
};

const MergeModal = ({ show, selectedStudent, students, onClose, onMerged }) => {
	const { state, dispatch, api } = useAppContext();
	const [merging, setMerging] = useState(false);
	const [error, setError] = useState(null);
	const [mergeInto, setMergeInto] = useState(null);
	const isReadOnly = useUserIsReadOnly();

	useEffect(() => {
		setMergeInto(null);
	}, [selectedStudent]);

	async function handleSubmit(event) {
		console.log(selectedStudent);
		console.log(mergeInto);
		event.preventDefault();
		setMerging(true);
		setError(null);
		const { data, error } = await api.fetchData(`/students/merge`, "POST", {
			merge_from_id: selectedStudent.student_id,
			merge_to_id: mergeInto.value,
		});
		if (data?.success) {
			setMerging(false);
			onMerged(selectedStudent.student_id);
		} else {
			setMerging(false);
			setError(error || data?.error || "An error occurred");
		}
	}

	function handleStudentChanged(student) {
		setMergeInto(student);
	}

	// Create student options not containing the selected student
	let studentOptions = students
		? students.map((student) => {
			if (student.student_id != selectedStudent?.student_id) {
				return {
					value: student.student_id,
					label: `${student.first_name} ${student.last_name}`,
				};
			}
		})
		: [];

	studentOptions = studentOptions.filter(function (el) {
		return el != null;
	});

	return (
		<Modal show={show} onHide={onClose} centered>
			<Modal.Header>
				<Modal.Title>Merge Participants</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="merge-students-modal">
					<div className="merge-students-modal__student-details">
						<p>
							Merging this Participant into another Participant will
							delete this Participant and combine all of their forms into
							the selected Participant.
						</p>
						<div className="student-info-header">
							<div className="student-info-header__name">
								{selectedStudent?.first_name}{" "}
								{selectedStudent?.last_name}
							</div>
							<div className="student-info-header__email">
								({selectedStudent?.email})
							</div>
						</div>
						<div className="merge-modal__student-select">
							<SelectInput
								name="student_id"
								label="Merge Participant Into..."
								value={mergeInto}
								onChange={handleStudentChanged}
								required
								options={studentOptions}
								placeholder="Select Participant"
							/>
						</div>
						{error && (
							<div className="mb-3">
								<AlertMessage type="danger" message={error} />
							</div>
						)}
						<Button
							text={merging ? "Merging..." : "Merge Participants"}
							type="success"
							onClick={handleSubmit}
							disabled={mergeInto == null || merging || isReadOnly}
						/>
					</div>
					<span className="merge-students-modal__cancel" onClick={onClose}>
						Cancel
					</span>
				</div>
			</Modal.Body>
		</Modal>
	);
};

const DeleteModal = ({ show, selectedStudent, courseId, onClose, onDeleted }) => {
	const { api } = useAppContext();
	const [deleting, setDeleting] = useState(false);
	const [error, setError] = useState(null);
	const isReadOnly = useUserIsReadOnly();

	async function handleDelete(event) {
		if (event) event.preventDefault();
		if (!selectedStudent) return;

		setDeleting(true);
		setError(null);

		const { data, error } = await api.fetchData(
			`/courses/${courseId}/students/${selectedStudent.student_id}/delete`,
			"POST"
		);

		if (data?.success) {
			setDeleting(false);
			onDeleted(selectedStudent.student_id);
		} else {
			setDeleting(false);
			setError(error || data?.error || "An error occurred while deleting the participant");
		}
	}

	return (
		<Modal show={show} onHide={onClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>Delete Participant</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="delete-student-modal">
					<div className="student-info-header mb-3">
						<div className="student-info-header__name">
							{selectedStudent?.first_name} {selectedStudent?.last_name}
						</div>
						<div className="student-info-header__email">
							({selectedStudent?.email})
						</div>
					</div>

					<p className="text-muted mb-3">
						Are you sure you want to delete this participant from this course?
					</p>

					<div className="alert alert-warning mb-3">
						<strong>Warning:</strong> This will permanently delete this participant's registration, attendance status, Health Questionnaire, physical competency assessment, and any associated forms for this course.
					</div>

					{error && (
						<div className="mb-3">
							<AlertMessage type="danger" message={error} />
						</div>
					)}
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button
					text="Cancel"
					type="outline-secondary"
					onClick={onClose}
					disabled={deleting}
				/>
				<Button
					text={deleting ? "Deleting..." : "Delete Participant"}
					type="danger"
					onClick={handleDelete}
					disabled={deleting || isReadOnly}
				/>
			</Modal.Footer>
		</Modal>
	);
};

export default AttendanceRegisterPage;
